<template>
    <CRow>
        <CCol col>
            <div style="width:100%; height: 80vh;">
                <ejs-grid ref='grid' :dataSource="fxDataLogs" :allowFiltering='true' :allowPaging="true" :allowResizing='true' :actionBegin="actionBegin"
                          :toolbarClick='toolbarClick' :allowExcelExport='true' :allowReordering='true' :allowSorting='true' :toolbar='toolbar' :excelQueryCellInfo='excelQueryCellInfo'
                          :pageSettings='pageSettings' :actionFailure="actionFailure" :actionComplete="actionComplete" :excelExportComplete='excelExportComplete' 
                          :filterSettings='filterOptions' width="100%" height="100%" :queryCellInfo='queryCellInfo' :query="gridQuery">
                    <e-columns>
                        <e-column field='id' headerText='Id' width=120 :isPrimaryKey='true' :visible='false'></e-column>
                        <e-column field='fxRateId' headerText='FXRate Id' typeof='string'></e-column>
                        <e-column field='currencyConversionName' headerText='Conversion Identifier' textAlign='Left' width=160></e-column>
                        <e-column field='currencyConversionId' headerText='Conversion Ric Root' textAlign='Left' :visible="false" width=190></e-column>
                        <e-column field='currencyConversionFrom' headerText='Currency from' textAlign='Left' width=160></e-column>
                        <e-column field='currencyConversionTo' headerText='Currency to' width=160></e-column>
                        <e-column field='date' headerText='Settlement Date' textAlign='Left' :format='dateFormatOptions' type='date' width=180></e-column>
                        <e-column field='rate' headerText='Settlement Price' textAlign='Left' format='n3' width=180></e-column>
                        <e-column field='createdBy' headerText='Created By' textAlign='Left' width=150></e-column>
                        <e-column field='createdDate' headerText='Import Date' textAlign='Left' :format='dateFormatOptions' type='date' width=150></e-column>
                        <e-column field='fxRateLogDate' headerText='Log Date' textAlign='Left' width=190 type="date" :format='dateFormatOptions'></e-column>
                        <e-column field='fxRateLogTimeStamp' headerText='Log Time' textAlign='Left' width=150 type="string"></e-column>
                        <e-column field='userName' headerText='User' textAlign='Left' width=150 type="string"></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import { GridPlugin, Toolbar, Page, Filter, Sort, Resize, Reorder, ExcelExport, ForeignKey} from '@syncfusion/ej2-vue-grids';
    import { Query } from '@syncfusion/ej2-data';
    import store from '../../store';
    import authToken from '../../common/authToken';
    import SyncHelper from '../../common/syncfusion';
    import gridOptions from '../../common/gridOptions';
    import dates from '../../common/dates';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

    Vue.use(GridPlugin)

    export default {
        components: {
        },
        data() {
            return {
                store: store,
                fxDataLogs: this.$store.state.permissions["Permissions.LatestSettlement.View"] ? SyncHelper.getDataManager("FXRateLogs") : [],
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy' },
                filterOptions: gridOptions.filterSettings,
                pageSettings: gridOptions.pageSettings,
                toolbar: ['ExcelExport'],
                gridQuery: new Query().addParams("timezoneOffset", new Date().getTimezoneOffset())                
            };

        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        methods: {
            toolbarClick: function (args) {
                if (args.item.id.includes('excelexport')) {
                    gridOptions.excelExport(args, 'FX Rates Logs.xlsx', this.$refs);
                }
            },
            actionComplete: function (args) {
                gridOptions.actionComplete(args, this.$refs);
                hideSpinner(document.getElementById('mainSpinner'));
            },
            actionFailure: function (args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },
            excelExportComplete: function () {
                this.$refs.grid.hideSpinner();
            },
            actionBegin(args) {
                gridOptions.actionBegin(args);
                if (args.requestType == 'refresh') {
                    hideSpinner(document.getElementById('mainSpinner'));
                }
            },
            addHeaders: function (args) {
                args.currentRequest.setRequestHeader('Authorization', `Bearer ${authToken.get()}`);
            },
            onFocus: function (args) {
                this.$refs.dateObj.show();
            },
            queryCellInfo(args) {
                
                if (args.column.field === 'fxRateLogTimeStamp') {
                    args.cell.textContent = this.convertUTCDateToLocalTime(args.data['fxRateLogTimeStamp']);
                }
            },
            excelQueryCellInfo(args) {

                if (args.column.field === 'fxRateLogTimeStamp') {
                    args.value = this.convertUTCDateToLocalTime(args.data['fxRateLogTimeStamp']);
                }
            },
            convertUTCDateToLocalTime(dateString) {
                const date = new Date(dateString)
                var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
                return newDate.toLocaleTimeString([], {
                    hourCycle: 'h23',
                    //hour: '2-digit',
                    //minute: '2-digit',
                });
            },

        },
        computed: {


        },
        provide: {
            grid: [Toolbar, Page, Filter, Reorder, Resize, Sort, ExcelExport, ForeignKey]

        }

    }
</script>

<style scoped>
</style>